import React, { memo } from 'react'
import { Button, DialogActions, DialogTitle, DialogContent, DialogContentText } from '@mui/material'
import ResponsiveDialog from 'components/ResponsiveDialog'

interface IFakeApplyDialogProps {
  open: boolean
  close: () => void
}

function FakeApplyDialog({ open, close }: IFakeApplyDialogProps) {
  if (!open) {
    return null
  }

  return (
    <ResponsiveDialog open onClose={close}>
      <DialogTitle>
        Apply Now
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          Only Flexhire members can apply to Jobs
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={close} data-cy="dialog-ok">
          OK
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}

export default memo(FakeApplyDialog)
